import { useSelector } from "react-redux";
import { selectData, selectLoading } from "./selector";

export const useLoading = () => useSelector(selectLoading);
export const useData = () => useSelector(selectData);
